exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UserCard-b5b043f5{text-align:left;display:flex;width:260px}.UserCard-b5b043f5 .profileImg-df426936{line-height:0;padding:15px}.UserCard-b5b043f5 .profileImg-df426936 img{height:50px;width:50px;border-radius:50%;box-shadow:1px 1px 4px 0 rgba(0,0,0,0.1)}.UserCard-b5b043f5 .username-d414d8f4{font-weight:500;color:#424242;font-size:14px}.UserCard-b5b043f5 .location-87a5ca9c{color:#757575;font-size:14px}.UserContent-db9296f2{padding-top:15px}.private-ec0fc483{padding:20px 20px}\n", ""]);

// Exports
exports.locals = {
	"UserCard": "UserCard-b5b043f5",
	"profileImg": "profileImg-df426936",
	"username": "username-d414d8f4",
	"location": "location-87a5ca9c",
	"UserContent": "UserContent-db9296f2",
	"private": "private-ec0fc483"
};